import ImagePerson from "@/components/functionals/ImagePerson.vue";
import HyperlinkForModuleVacations from "@/views/apps/employees/RRHH/Modules/hyperLink/HyperlinkForModuleVacations.vue";
// import HyperlinkForModuleVacations from "@/views/apps/employees/RRHH/Modules/hyperLink/HyperlinkForModulePermission.vue";

import { formatDate } from "@/utils";

export default [
  {
    prop: "Name",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    fixed: true,
    attrs: {
      imgKey: "imageUrl"
    }
  },
  {
    prop: "StartDate",
    label: "Fecha Ingreso",
    width: 140,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.StartDate, "DD/MM/YYYY");
    }
  },
  {
    label: "Dias de Vacaciones",
    width: 170,
    sortable: true,
    formatter: () => {
      return 14;
    }
  },
  {
    prop: "DiasSolicitados",
    label: "Dias Solicitados",
    width: 160,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "DiasAprobados",
    label: "Dias Aprobados",
    width: 160,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "DiasEjecutados",
    label: "Dias Ejecutados",
    width: 160,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Enero",
    label: "Enero",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Febrero",
    label: "Febrero",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Marzo",
    label: "Marzo",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Abril",
    label: "Abril",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Mayo",
    label: "Mayo",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Junio",
    label: "Junio",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Julio",
    label: "Julio",
    sortable: true,
    width: 125,
    cellAtrrs: {
      mes: 7
    },
    formatter: HyperlinkForModuleVacations
  },

  {
    prop: "Agosto",
    label: "Agosto",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Septiembre",
    label: "Septiembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 9
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Octubre",
    label: "Octubre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 10
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Noviembre",
    label: "Noviembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 11
    },
    formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Diciembre",
    label: "Diciembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 12
    },
    formatter: HyperlinkForModuleVacations
  }
];
